import * as React from 'react'
import { cn } from '@merels/ui'

import { useTheme } from '../../../../contexts/ThemeContext'
import { mateListTestIds } from '../MateList/mateList.testIds'

export interface MateListPanelProps {
  className?: string
  children: React.ReactNode
}

/**
 * MateListPanel is the structural wrapper for the mate list sidebar.
 *
 * Responsibilities:
 * - Provide the `<aside>` element and its layout classes.
 * - Match the play area background (app theme background).
 */
export const MateListPanel = React.forwardRef<HTMLElement, MateListPanelProps>(
  ({ className, children }, ref) => {
    const { getAppColor } = useTheme()
    const appColorShades = getAppColor()

    return (
      <aside
        ref={ref}
        data-testid={mateListTestIds.sidebar}
        className={cn('w-[160px] flex flex-col overflow-hidden', className)}
        style={{ backgroundColor: appColorShades.background }}
      >
        {children}
      </aside>
    )
  },
)
MateListPanel.displayName = 'MateListPanel'
